import { Panel } from '../../../../../components/panel/Panel';

import { Assignment } from './components/assignment/Assignment';
import { Billing } from './components/billing/Billing';
import { Description } from './components/description/Description';
import { Note } from './components/note/Note';
import { Organisation } from './components/organisation/Organisation';
import { SubscriptionContract } from './components/subscription-contract/SubscriptionContract';

export const GeneralTabPanel = () => {
  return (
    <Panel restrictedWidth>
      <Description />
      <SubscriptionContract />
      <Billing />
      <Assignment />
      <Organisation />
      <Note />
    </Panel>
  );
};
